
function BeachesEn() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/coast-img/sandburg.jpg" alt="sandcastle" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Wismar's beaches</h1>
                            <p>There's not just one? That's right, Wismar has several beaches. You can get an overview 
                                of the most important and most easily accessible ones here.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Poel Am Schwarzen Busch</h2>
                            <p>The Poel peninsula is located north-east of Wismar. It can be easily reached by 
                                ferry, car or bicycle. The beach Am Schwarzen Busch is located north of the peninsula 
                                and is one of Wismar's best known beaches.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Poel Timmendorf</h2>
                            <p>Wismar also has a Timmendorf beach. Not to be confused with the one in Schleswig-Holstein. 
                                Timmendorfer Strand on Poel is located in the western part of the peninsula. Don't forget 
                                to bring some coins, a small beach fee or visitor's tax needs to be paid at the beaches for 
                                the duration of your stay.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wendorf</h2>
                            <p>Wendorf beach is the closest and quickest to reach from Apartment 5. It is located on the 
                                western coastline. The associated Bad Wendorf pier is ideal for short walks, for example 
                                after an extensive lunch at the Hotel Seeblick next door.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Zierow</h2>
                            <p>Further along the western coast is the Zierow bathing beach. Here you will find pure nature - 
                                although the beach is rather small, it is less well-known and therefore less crowded. 
                                For snacks & co. it is best to go to the small town of Zierow.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Hohen Wieschendorf</h2>
                            <p>A few metres further on you reach Hohen Wieschendorf, a small beach paradise with a jetty 
                                and therefore also accessible by boat. The Little Italy restaurant is the perfect place to 
                                enjoy a hearty lunch or a delicious dinner. Those who also want to swing a golf club will 
                                get their money's worth at the Bades Huk Golf Club.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Beckerwitz</h2>
                            <p>Once around the headland, you will find the small village of Beckerwitz and its beach. 
                                A picture-book beach with light-coloured sand, small cliffs and tall trees. Beckerwitz 
                                is best reached by car from Apartment 5, but there is also a bus service available.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wohlenberger Wiek</h2>
                            <p>The light sandy beach stretches from Beckerwitz to Wohlenberger Wiek. Ideal for a one-hour 
                                walk along the Baltic Sea waves. Several parking areas at regular intervals also allow you 
                                to arrive by car. Again, be sure to bring some coins for the beach fee.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default BeachesEn;